import userReducer from './userReducer'
import listReducer from './listReducer'
import { combineReducers } from 'redux'

const allReducers = combineReducers({
  user: userReducer,
  rabbitHoles: listReducer,
})
export default allReducers
